<template>
    <div class="feature-list__one">
        <div class="row">
            <div v-for="(item, x) in items" :key="x" class="col-lg-6 wow move-up">
                <div class="grid-item animate">
                    <div class="ht-box-icon style-01">
                        <div class="icon-box-wrap">
                            <div class="image">
                                <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01">
                            </div>
                            <div class="content">
                                <h6 class="heading">{{ item.heading }}</h6>
                                <div class="text">{{ item.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureApp',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-01.png'), 
                        heading: 'Store, Discuss & Records', 
                        text: 'Keeping all your cases data accessible for further study can make further enhance your practice quality level.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-02.png'), 
                        heading: 'Tailor Forms & Records to Your Needs', 
                        text: 'Adjust forms so that saving and registering data is done with ease by physicians.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-03.png'), 
                        heading: 'Save Time & Keep Efficient', 
                        text: 'Increase your productivity by recording patient and case data only once.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-04.png'), 
                        heading: 'Use & Access at Your Convenience', 
                        text: 'Utilise this app from mobile and desktop devices, as needed, whenever.'
                    },
                ]
            }
        }
    }
</script>
